import React, { useState } from 'react';

/**
 * Click-to-play YouTube card. Renders only the thumbnail until clicked (so the
 * homepage doesn't load N iframes), then loads a privacy-friendly nocookie embed.
 */
const VideoCard = ({ video }) => {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="group bg-white border border-line rounded-3xl overflow-hidden">
      <div className="relative aspect-video bg-ink">
        {playing ? (
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <button
            type="button"
            onClick={() => setPlaying(true)}
            className="absolute inset-0 w-full h-full"
            aria-label={`Play video: ${video.title}`}
          >
            <img
              src={`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`}
              alt={video.title}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute inset-0 bg-ink/10 group-hover:bg-ink/0 transition-colors" />
            <span className="absolute inset-0 grid place-items-center">
              <span className="grid place-items-center w-16 h-16 rounded-full bg-amber text-ink shadow-pop transition-transform duration-200 group-hover:scale-110">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z" /></svg>
              </span>
            </span>
          </button>
        )}
      </div>
      <div className="p-5">
        <span className="text-xs font-bold uppercase tracking-[0.08em] text-muted">Meet the maker</span>
        <strong className="block text-ink font-extrabold mt-1 truncate">{video.maker}</strong>
      </div>
    </div>
  );
};

export default VideoCard;
